<template>
  <article id="root">
    <div id="info">
      <img id="logo" alt="FINNOMENA" src="../assets/logo.png" />
      <p>{{version}}</p>
    </div>
  </article>
</template>
<script>
export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION
    };
  },
  metaInfo: {
    title: "FINNOMENA"
  },
  components: {},
  async mounted() {},
  watch: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
#root {
  padding: 5%;
  background-color: $color-primary-finno;
  height: 100vh;
  width: 100%;
  text-align: center;
  vertical-align: middle;

  #info {
    position: fixed;
    top: 50%;
    left: 50%;
    /* bring your own prefixes */
    transform: translate(-50%, -50%);
    filter: brightness(0) invert(1);

    -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadein 2s; /* Firefox < 16 */
    -ms-animation: fadein 2s; /* Internet Explorer */
    -o-animation: fadein 2s; /* Opera < 12.1 */
    animation: fadein 2s;
  }

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Firefox < 16 */
  @-moz-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Safari, Chrome and Opera > 12.1 */
  @-webkit-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Internet Explorer */
  @-ms-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Opera < 12.1 */
  @-o-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}
</style>




